module.exports = __webpack_public_path__ + "static/media/2.4e13d50d.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/img/有機純抹茶奶酥醬/2.JPG
// module id = 937
// module chunks = 0